import { REPEATED_APOSTA } from "../relatorios/suasapostasActions";

const REPETICAO_INITIAL_STATE = {
  arrAposta: [],
};

export default (state = REPETICAO_INITIAL_STATE, action) => {
  switch (action.type) {
    case REPEATED_APOSTA:
      return {
        ...state,
        arrAposta: action.payload.arrApostas,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/repeticao/repeticaoReducer.js